import { ss } from '@/utils/storage'

const LOCAL_NAME = 'promptStore'

export type PromptList = any[]

export interface PromptStore {
  promptList: PromptList
}

export function getLocalPromptList(): PromptStore {
  const promptStore: PromptStore | undefined = ss.get(LOCAL_NAME)
  // return promptStore ?? { promptList: [{ key: '概念解读', value: '概念解读' }, { key: '人群分析', value: '人群分析' }] }
  return promptStore ?? { promptList: [] }
}

export function setLocalPromptList(promptStore: PromptStore): void {
  ss.set(LOCAL_NAME, promptStore)
}
